import api from '@/api';

/**
 * Fetch for-sale vehicle list matrix for LPMS.
 *
 * Backend endpoint: /api/v1/lpms/for-sale-vehicle-list
 * Note: our axios instance already prefixes requests with "/api".
 *
 * @returns {Promise<string[][]>} Array of columns, each an array of plate numbers (strings).
 */
export async function getForSaleVehicleList() {
  return (await api.get('v1/lpms/for-sale-vehicle-list')).data;
}
